module.exports = __webpack_public_path__ + "static/media/jielong.84ae56dd.svg";